module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAJUlEQVQ4T2NgGBTgjIjqf3TMtbgYBUuGH8fAowaMGjDIDBjaAADmyEXaP/akMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/_mars.png
// module id = 1315
// module chunks = 0